import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ROUTES } from '../../common-files/enums/server-routes';

@Injectable({
  providedIn: 'root',
})
export class AdvanceSearchService {
  constructor(private http: HttpClient) {}

  fetchProfile(payload: any): Observable<any> {
    return this.http.post(ROUTES.PROFILE_SEARCH, payload);
  }

  fetchProfileDetails(fc: any): Observable<any> {
    return this.http.get(`${ROUTES.PROFILE_DETAILS}/${fc}`);
  }

  fetchProfileDetailsWithProfileY(fc: any): Observable<any> {
    return this.http.get(`${ROUTES.FC_DETAILS}/${fc}?profile=y`);
  }

  fetchVisitorsDetails(fc: any): Observable<any> {
    return this.http.get(`${ROUTES.VISITORS_DETAILS}/${fc}`);
  }

  fetchPincode(pin: string | number, district?: string): Observable<any> {
    let params = new HttpParams();
    if (district) params = params.set('district', district);
    return this.http.get(`${ROUTES.PINCODE}/${pin}`, { params });
  }

  fetchStates(): Observable<any> {
    return this.http.get(ROUTES.STATES);
  }

  fetchBookingDetails(payload: any): Observable<any> {
    return this.http.post(ROUTES.BOOKING_DETAILS, payload);
  }

  fetchBookingId(id: any): Observable<any> {
    return this.http.get(`${ROUTES.BOOKING_ID}/${id}`);
  }

  fetchVisitDetails(payload: any): Observable<any> {
    return this.http.post(ROUTES.VISIT_DETAILS, payload);
  }

  updateMemDetails(payload: any): Observable<any> {
    return this.http.put(ROUTES.SEND_REQ_OTP, payload);
  }

  sendReqToUpdate(payload: any): Observable<any> {
    return this.http.put(ROUTES.PROFILE_DETAILS, payload);
  }

  updateName(payload: any): Observable<any> {
    return this.http.patch(ROUTES.EDIT_NAME, payload);
  }

  updateVisitor(payload: any): Observable<any> {
    return this.http.patch(ROUTES.UPDATE_VISITOR_DETAILS, payload);
  }

  fetchContactNumbers(fc: any): Observable<any> {
    return this.http.get(`${ROUTES.CONTACT_NUMBERS}/${fc}`);
  }

  fetchAvailableContactNumber(payload: any): Observable<any> {
    return this.http.post(ROUTES.AVAILABLE_CONTACT_NUMBERS, payload);
  }

  fetchPrimaryRequest(payload: any): Observable<any> {
    return this.http.put(ROUTES.PRIMARY_REQ, payload);
  }

  verifyPrimaryOtp(payload: any): Observable<any> {
    return this.http.put(ROUTES.PRIMARY_VERIFY, payload);
  }

  fetchDevoteeAddress(id: any): Observable<any> {
    return this.http.get(`${ROUTES.DEVOTEE_ADDRESS}/${id}`);
  }

  fetchDevoteeAddressbyDevoteeId(id: any): Observable<any> {
    return this.http.get(`${ROUTES.IMPORT_ADDRESS_BY_DEVOTEE_ID}/${id}`);
  }

  UpdatePrimaryDevotee(payload: any): Observable<any> {
    return this.http.put(ROUTES.UPDATE_DEVOTEE_FC, payload);
  }

  ValidateDevoteeFc(payLoad: any): Observable<any> {
    return this.http.post(ROUTES.VALIDATE_DEVOTEE_FC, payLoad);
  }

  ValidateNewFc(payLoad: any): Observable<any> {
    return this.http.post(ROUTES.VALIDATE_NEW_FC, payLoad);
  }

  fetchPhilDetails(fc: any): Observable<any> {
    return this.http.get(`${ROUTES.FC_DETAILS}/${fc}`);
  }

  // add-user dialogs: is this management username free?
  checkUsernameAvailability(userName: string): Observable<any> {
    return this.http.get(ROUTES.USERNAME_AVAILABILITY, { params: { userName } });
  }

  // add-user dialogs: does the picked family member already hold an account?
  checkMemberAvailability(memUuid: string): Observable<any> {
    return this.http.get(ROUTES.MEMBER_AVAILABILITY, { params: { memUuid } });
  }

  UpdateDevoteeAadhar(payLoad: any): Observable<any> {
    return this.http.patch(ROUTES.UPDATE_DEVOTEE_AADHAR, payLoad);
  }

  UpdateVisitorAadhar(payLoad: any): Observable<any> {
    return this.http.patch(ROUTES.UPDATE_VISITOR_AADHAR, payLoad);
  }

  UpdateDevoteeNumber(payLoad: any): Observable<any> {
    return this.http.put(ROUTES.UPDATE_CONTACT_DEVOTEE, payLoad);
  }

  UpdateManualName(payLoad: any): Observable<any> {
    return this.http.delete(ROUTES.RESOLVE_NAME_AND_MEMBER_CODE, {
      body: payLoad,
    });
  }

  UpdateManualAdhaar(payLoad: any): Observable<any> {
    return this.http.delete(ROUTES.RESOLVE_AADHAR_CONFLICT_AND_INACTIVATE, {
      body: payLoad,
    });
  }

  UpdateManualPhone(payLoad: any): Observable<any> {
    return this.http.post(ROUTES.ASSIGN_NEW_CONTACT, payLoad);
  }

  UpdateManualStatus(payLoad: any): Observable<any> {
    return this.http.patch(ROUTES.MANUAL_STATUS_UPDATE, payLoad);
  }

  UpdateAllFamilyCode(payload: any): Observable<any> {
    return this.http.put(ROUTES.ALL_FAMILY_CODE_CHANGE_REQ,payload);
  }

  getOccupancyStats(date: string): Observable<any> {
    return this.http.get(`${ROUTES.OCCUPANCY_STATS}/${date}`);
  }
}
